<template>
  <div class="circle-area">
    <v-row justify="center">
      <v-icon class="icon">mdi-information-outline</v-icon>
      <p>{{alertText}}</p>
    </v-row>
  </div>
</template>

<script>

export default {
  name: "AlertText",
  data: () => ({
  }),
  methods: {
  },
  created() {
  },
  components: {
  },
  props: ['alertText']
};

</script>

<style scoped>
.circle-area {
  background-color: #0000004d;
  height: 48px;
  border-radius: 24px;
  position: relative;
}
p {
  padding: 10px 0;
  color: #fff;
  font-weight: bold;
  margin: 0;
}
.icon {
  position: absolute;
  left: 20px;
  padding: 10px 0;
  color: #fff;
}
@media screen and (max-width: 350px) {
  p {
    font-size: 0.8em;
    padding: 14px 0;
  }
}
@media screen and (min-width: 351px) and (max-width: 768px) {
  p {
    font-size: 1em;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
}
@media screen and (min-width: 1024px) {
}
</style>
